// Generated by ReScript, PLEASE EDIT WITH CARE


let postalCode = [
  {
    note: "The first two digits (ranging from 10–43) correspond to the province, while the last two digits correspond either to the city/delivery zone (range 01–50) or to the district/delivery zone (range 51–99). Afghanistan Postal code lookup",
    country: "Afghanistan",
    iso: "AF",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "With Finland, first two numbers are 22.",
    country: "Åland Islands",
    iso: "AX",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Introduced in 2006, gradually implemented throughout 2007.",
    country: "Albania",
    iso: "AL",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "First two as in ISO 3166-2:DZ",
    country: "Algeria",
    iso: "DZ",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "U.S. ZIP codes (range 96799)",
    country: "American Samoa",
    iso: "AS",
    format: "NNNNN (optionally NNNNN-NNNN or NNNNN-NNNNNN)",
    regex: "^\\d{5}(-{1}\\d{4,6})$"
  },
  {
    note: "Each parish now has its own post code.",
    country: "Andorra",
    iso: "AD",
    format: "CCNNN",
    regex: "^[Aa][Dd]\\d{3}$"
  },
  {
    note: "",
    country: "Angola",
    iso: "AO",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Single code used for all addresses.",
    country: "Anguilla",
    iso: "AI",
    format: "AI-2640",
    regex: "^[Aa][I][-][2][6][4][0]$"
  },
  {
    note: "",
    country: "Antigua and Barbuda",
    iso: "AG",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Codigo Postal Argentino (CPA), where the first A is the province code as in ISO 3166-2:AR, the four numbers are the old postal codes, the three last letters indicate a side of the block. Previously NNNN which &#10;o the minimum requirement as of 2006.",
    country: "Argentina",
    iso: "AR",
    format: "1974-1998 NNNN; From 1999 ANNNNAAA",
    regex: "^\\d{4}|[A-Za-z]\\d{4}[a-zA-Z]{3}$"
  },
  {
    note: "Previously used NNNNNN system inherited from former Soviet Union.",
    country: "Armenia",
    iso: "AM",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Aruba",
    iso: "AW",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Single code used for all addresses. Part of UK system.",
    country: "Ascension island",
    iso: "AC",
    format: "AAAANAA one code: ASCN 1ZZ",
    regex: "^[Aa][Ss][Cc][Nn]\\s{0,1}[1][Zz][Zz]$"
  },
  {
    note: "In general, the first digit identifies the state or territory.",
    country: "Australia",
    iso: "AU",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "The first digit denotes regions, which are partly identical to one of the nine provinces—called Bundesländer; the last the nearest post office in the area.",
    country: "Austria",
    iso: "AT",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Previously used NNNNNN system inherited from former Soviet Union.",
    country: "Azerbaijan",
    iso: "AZ",
    format: "CCNNNN",
    regex: "^[Aa][Zz]\\d{4}$"
  },
  {
    note: "",
    country: "Bahamas",
    iso: "BS",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Valid post code numbers are 101 to 1216 with gaps in the range. Known as block number (Arabic: رقم المجمع‎) formally. The first digit in NNN format and the first two digits in NNNN format refer to one of the 12 municipalities of the country. PO Box address doesn't need a block number or city name, just the PO Box number followed by the name of the country, Bahrain.",
    country: "Bahrain",
    iso: "BH",
    format: "NNN or NNNN",
    regex: "^\\d{3,4}$"
  },
  {
    note: "",
    country: "Bangladesh",
    iso: "BD",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Only one postal code currently assigned. 11000 applies to the General Post Office building in Cheapside, Bridgetown, to enable delivery to Barbados by global package delivery companies whose software requires a postal code.",
    country: "Barbados",
    iso: "BB",
    format: "CCNNNNN",
    regex: "^[Aa][Zz]\\d{5}$"
  },
  {
    note: "Retained system inherited from former Soviet Union.",
    country: "Belarus",
    iso: "BY",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "In general, the first digit gives the province.",
    country: "Belgium",
    iso: "BE",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Belize",
    iso: "BZ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Benin",
    iso: "BJ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "AA NN for street addresses, AA AA for P.O. Box addresses. The second half of the postcode identifies the street delivery walk (e.g.: Hamilton HM 12) or the PO Box number range (e.g.: Hamilton HM BX). See Postal codes in Bermuda.",
    country: "Bermuda",
    iso: "BM",
    format: "AA NN or AA AA",
    regex: "^[A-Za-z]{2}\\s([A-Za-z]{2}|\\d{2})$"
  },
  {
    note: "",
    country: "Bhutan",
    iso: "BT",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Bolivia",
    iso: "BO",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Bonaire, Sint Eustatius and Saba",
    iso: "BQ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Bosnia and Herzegovina",
    iso: "BA",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Botswana",
    iso: "BW",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Código de Endereçamento Postal (CEP): -000 to -899 are used for streets, roads, avenues, boulevards; -900 to -959 are used for buildings with a high postal use; -960 to -969 are for promotional use; -970 to -989 are post offices and regular P.O. boxes; and -990 to -998 are used for community P.O. boxes. -999 is used for special services.",
    country: "Brazil",
    iso: "BR",
    format: "NNNNN-NNN (NNNNN from 1971 to 1992)",
    regex: "^\\d{5}-\\d{3}$"
  },
  {
    note: "Single code used for all addresses.",
    country: "British Antarctic Territory",
    iso: "",
    format: "BIQQ 1ZZ",
    regex: "^[Bb][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "UK territory, but not UK postcode.",
    country: "British Indian Ocean Territory",
    iso: "IO",
    format: "AAAANAA one code: BBND 1ZZ",
    regex: "^[Bb]{2}[Nn][Dd]\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "Specifically, VG1110 through VG1160[1]",
    country: "British Virgin Islands",
    iso: "VG",
    format: "CCNNNN",
    regex: "^[Vv][Gg]\\d{4}$"
  },
  {
    note: "",
    country: "Brunei",
    iso: "BN",
    format: "AANNNN",
    regex: "^[A-Za-z]{2}\\d{4}$"
  },
  {
    note: "",
    country: "Bulgaria",
    iso: "BG",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Burkina Faso",
    iso: "BF",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Burundi",
    iso: "BI",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Cambodia",
    iso: "KH",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Cameroon",
    iso: "CM",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "The system was gradually introduced starting in April 1971 in Ottawa. The letters D, F, I, O, Q, and U are not used to avoid confusion with other letters or numbers.",
    country: "Canada",
    iso: "CA",
    format: "ANA NAN",
    regex: "^(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\s{0,1}\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d$"
  },
  {
    note: "The first digit indicates the island.",
    country: "Cape Verde",
    iso: "CV",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Cayman Islands",
    iso: "KY",
    format: "CCN-NNNN",
    regex: "^[Kk][Yy]\\d[-\\s]{0,1}\\d{4}$"
  },
  {
    note: "",
    country: "Central African Republic",
    iso: "CF",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Chad",
    iso: "TD",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "May only be required for bulk mail.",
    country: "Chile",
    iso: "CL",
    format: "NNNNNNN (NNN-NNNN)",
    regex: "^\\d{7}\\s\\(\\d{3}-\\d{4}\\)$"
  },
  {
    note: "A postal code or youbian (邮编) in a subordinate division will have the same first two digits as its governing one (see Political divisions of China. The postal services in Macau or Hong Kong Special Administrative Regions remain separate from Mainland China, with no post code system currently used.",
    country: "China",
    iso: "CN",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Part of the Australian postal code system.",
    country: "Christmas Island",
    iso: "CX",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Part of the Australian postal code system.",
    country: "Cocos (Keeling) Island",
    iso: "CC",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "First NN = 32 departments Códigos Postales | 4-72",
    country: "Colombia",
    iso: "CO",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "",
    country: "Comoros",
    iso: "KM",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Congo (Brazzaville)",
    iso: "CG",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Congo, Democratic Republic",
    iso: "CD",
    format: "- no codes -",
    regex: "^[Cc][Dd]$"
  },
  {
    note: "",
    country: "Cook Islands",
    iso: "CK",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "First codes the provinces, next two the canton, last two the district.",
    country: "Costa Rica",
    iso: "CR",
    format: "NNNNN (NNNN until 2007)",
    regex: "^\\d{4,5}$"
  },
  {
    note: "",
    country: "Côte d'Ivoire (Ivory Coast)",
    iso: "CI",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Croatia",
    iso: "HR",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "May only be required for bulk mail. The letters CP are frequently used before the postal code. This is not a country code, but an abbreviation for \"codigo postal\" or postal code.",
    country: "Cuba",
    iso: "CU",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Curaçao",
    iso: "CW",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Post code system covers whole island, but not used in Northern Cyprus where 'Mersin 10, Turkey' is used instead.",
    country: "Cyprus",
    iso: "CY",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "With Slovak Republic, Poštovní směrovací číslo (PSČ) - postal routing number.",
    country: "Czech Republic",
    iso: "CZ",
    format: "NNNNN (NNN NN)",
    regex: "^\\d{5}\\s\\(\\d{3}\\s\\d{2}\\)$"
  },
  {
    note: "Numbering follows the dispatch of postal trains from Copenhagen.[3] Also used by Greenland, e.g.: DK-3900 Nuuk.",
    country: "Denmark",
    iso: "DK",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Djibouti",
    iso: "DJ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Dominica",
    iso: "DM",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Dominican Republic",
    iso: "DO",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "No postal code system in use since Indonesian withdrawal in 1999.",
    country: "East Timor",
    iso: "TL",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Ecuador",
    iso: "EC",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Used for all inbound mail to El Salvador. The postal office then distributes the mail internally depending on their destination.",
    country: "El Salvador",
    iso: "SV",
    format: "1101",
    regex: "^1101$"
  },
  {
    note: "",
    country: "Egypt",
    iso: "EG",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Equatorial Guinea",
    iso: "GQ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Eritrea",
    iso: "ER",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Estonia",
    iso: "EE",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "The code is only used on a trial basis for Addis Ababa addresses.",
    country: "Ethiopia",
    iso: "ET",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "UK territory, but not UK postcode",
    country: "Falkland Islands",
    iso: "FK",
    format: "AAAANAA one code: FIQQ 1ZZ",
    regex: "^[Ff][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "Self-governing territory within the Kingdom of Denmark, but not Danish postcode.",
    country: "Faroe Islands",
    iso: "FO",
    format: "NNN",
    regex: "^\\d{3}$"
  },
  {
    note: "",
    country: "Fiji",
    iso: "FJ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "A lower first digit indicates a place in south (for example 00100 Helsinki), a higher indicates a place further to north (99800 in Ivalo). The last digit is usually 0, except for postal codes for PO Box number ranges, in which case it is 1. Country code for Finland: \"FI\". In the Åland Islands, the postal code is prefixed with \"AX\", not \"FI\". Some postal codes for rural settlements may end with 5, and there are some unique postal codes for large companies and institutions, e.g. 00014 HELSINGIN YLIOPISTO (university), 00102 EDUSKUNTA (parliament), 00020 NORDEA (a major Scandinavian bank).",
    country: "Finland",
    iso: "FI",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "The first two digits give the département number, while in Paris, Lyon and Marseille, the last two digits of the postal code indicates the arrondissement. Both of the 2 corsican départements use \"20\" as the first two digits. Also used by French overseas departments and territories. Monaco is also part of the French postal code system, but the country code MC- is used for Monegasque addresses.",
    country: "France",
    iso: "FR",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Overseas Department of France. French codes used. Range 97300 - 97390.",
    country: "French Guiana",
    iso: "GF",
    format: "973NN",
    regex: "^973\\d{2}$"
  },
  {
    note: "Overseas Department of France. French codes used. Range 98700 - 98790.",
    country: "French Polynesia",
    iso: "PF",
    format: "987NN",
    regex: "^987\\d{2}$"
  },
  {
    note: "French codes in the 98400 range have been reserved.",
    country: "French Southern and Antarctic Territories",
    iso: "TF",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Two digit postal zone goes after city name.",
    country: "Gabon",
    iso: "GA",
    format: "NN [city name] NN",
    regex: "^\\d{2}\\s[a-zA-Z-_ ]\\s\\d{2}$"
  },
  {
    note: "",
    country: "Gambia",
    iso: "GM",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Georgia",
    iso: "GE",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Postleitzahl (PLZ)",
    country: "Germany",
    iso: "DE",
    format: "NN",
    regex: "^\\d{2}$"
  },
  {
    note: "Postleitzahl (PLZ)",
    country: "Germany",
    iso: "DE",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Postleitzahl (PLZ), introduced after the German reunification. Between 1989 and 1993 the old separate 4-digit postal codes of former West- and East-Germany were distinguished by preceding \"W-\" or \"O-\" ('Ost' for East).",
    country: "Germany",
    iso: "DE",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "[citation needed]",
    country: "Ghana",
    iso: "GH",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Single code used for all addresses.",
    country: "Gibraltar",
    iso: "GI",
    format: "GX11 1AA",
    regex: "^[Gg][Xx][1]{2}\\s{0,1}[1][Aa]{2}$"
  },
  {
    note: "",
    country: "Greece",
    iso: "GR",
    format: "NNN NN",
    regex: "^\\d{3}\\s{0,1}\\d{2}$"
  },
  {
    note: "Part of the Danish postal code system.",
    country: "Greenland",
    iso: "GL",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Grenada",
    iso: "GD",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Overseas Department of France. French codes used. Range 97100 - 97190.",
    country: "Guadeloupe",
    iso: "GP",
    format: "971NN",
    regex: "^971\\d{2}$"
  },
  {
    note: "U.S. ZIP codes. Range 96910 - 96932.",
    country: "Guam",
    iso: "GU",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "The first two numbers identify the department, the third number the route and the last two the office.",
    country: "Guatemala",
    iso: "GT",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "UK-format postcode (first two letters are always GY not GG)",
    country: "Guernsey",
    iso: "GG",
    format: "AAN NAA, AANN NAA",
    regex: "^[A-Za-z]{2}\\d\\s{0,1}\\d[A-Za-z]{2}$"
  },
  {
    note: "",
    country: "Guinea",
    iso: "GN",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Guinea Bissau",
    iso: "GW",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Guyana",
    iso: "GY",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Haiti",
    iso: "HT",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Part of the Australian postcode system.",
    country: "Heard and McDonald Islands",
    iso: "HM",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Honduras",
    iso: "HN",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "[1] The dummy postal code of Hong Kong is 999077 but it is unnecessary in fact",
    country: "Hong Kong",
    iso: "HK",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "The code defines an area, usually one code per settlement except the six largest towns. One code can identify more (usually) small settlements as well.",
    country: "Hungary",
    iso: "HU",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Iceland",
    iso: "IS",
    format: "NNN",
    regex: "^\\d{3}$"
  },
  {
    note: "Postal Index Number (PIN)",
    country: "India",
    iso: "IN",
    format: "NNNNNN,&#10;NNN NNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Kode Pos. Included East Timor (ranges 88xxx and 89xxx) until 1999, no longer used. For Indonesia postal code information visit [2]",
    country: "Indonesia",
    iso: "ID",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "(Persian: کد پستی)",
    country: "Iran",
    iso: "IR",
    format: "NNNNN-NNNNN",
    regex: "^\\d{5}-\\d{5}$"
  },
  {
    note: "",
    country: "Iraq",
    iso: "IQ",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Currently no postal codes; however, Dublin is divided into postal districts on syntax Dublin 9. A national post code system is planned. See also Republic of Ireland postal addresses.",
    country: "Ireland",
    iso: "IE",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "UK-format postcode. The first two letters are always IM.",
    country: "Isle of Man",
    iso: "IM",
    format: "CCN NAA, CCNN NAA",
    regex: "^[Ii[Mm]\\d{1,2}\\s\\d\\[A-Z]{2}$"
  },
  {
    note: "Postcode is always written BEFORE the city/place name, i.e. to the Right in Hebrew or Arabic script - to the Left in Latin script.  This also allows the legacy postal code version (even though deprecated) since it's still in high use.",
    country: "Israel",
    iso: "IL",
    format: "NNNNNNN, NNNNN",
    regex: "^\\b\\d{5}(\\d{2})?$"
  },
  {
    note: "Codice di Avviamento Postale (CAP). Also used by San Marino and Vatican City. First two digits identify province with some exceptions, because there are more than 100 provinces.",
    country: "Italy",
    iso: "IT",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Jamaica currently has no national postal code system, except for Kingston and Lower St. Andrew, which are divided into postal districts numbered 1-20[4] &#10;Before the 2007 suspension, the first two letters of a national post code were always 'JM' (for Jamaica) while the third was for one of the four zones (A-D) into which the island was divided. The last two letters were for the parish, while the two digits were for the local post office.[5]",
    country: "Jamaica",
    iso: "JM",
    format: "Before suspension: CCAAANN &#10;After suspension: NN",
    regex: "^\\d{2}$"
  },
  {
    note: "See also Japanese addressing system.",
    country: "Japan",
    iso: "JP",
    format: "NNNNNNN (NNN-NNNN)",
    regex: "^\\d{7}\\s\\(\\d{3}-\\d{4}\\)$"
  },
  {
    note: "UK-format postcode.",
    country: "Jersey",
    iso: "JE",
    format: "CCN NAA",
    regex: "^[Jj][Ee]\\d\\s{0,1}\\d[A-Za-z]{2}$"
  },
  {
    note: "Deliveries to PO Boxes only.",
    country: "Jordan",
    iso: "JO",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "[6]",
    country: "Kazakhstan",
    iso: "KZ",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Deliveries to PO Boxes only. The postal code refers to the post office at which the receiver's P. O. Box is located.",
    country: "Kenya",
    iso: "KE",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Kiribati",
    iso: "KI",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Korea, North",
    iso: "KP",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Korea, South",
    iso: "KR",
    format: "NNNNNN (NNN-NNN)(1988~2015)",
    regex: "^\\d{6}\\s\\(\\d{3}-\\d{3}\\)$"
  },
  {
    note: "A separate postal code for Kosovo was introduced by the UNMIK postal administration in 2004. Serbian postcodes are still widely used in the Serbian enclaves. No country code has been assigned.",
    country: "Kosovo",
    iso: "XK",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "The first two digits represent the sector and the last three digits represents the post office.",
    country: "Kuwait",
    iso: "KW",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Kyrgyzstan",
    iso: "KG",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "",
    country: "Latvia",
    iso: "LV",
    format: "LV-NNNN",
    regex: "^[Ll][Vv][- ]{0,1}\\d{4}$"
  },
  {
    note: "",
    country: "Laos",
    iso: "LA",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "The first four digits represent the region or postal zone,the last four digits represent the building see also Lebanon Postal code website.",
    country: "Lebanon",
    iso: "LB",
    format: "NNNN NNNN",
    regex: "^\\d{4}\\s{0,1}\\d{4}$"
  },
  {
    note: "",
    country: "Lesotho",
    iso: "LS",
    format: "NNN",
    regex: "^\\d{3}$"
  },
  {
    note: "Two digit postal zone after city name.",
    country: "Liberia",
    iso: "LR",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Libya",
    iso: "LY",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "With Switzerland, ordered from west to east. Range 9485 - 9498.",
    country: "Liechtenstein",
    iso: "LI",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "References: http://www.post.lt/en/help/postal-code-search. Previously 9999 which was actually the old Soviet 999999 format code with the first 2 digits dropped.",
    country: "Lithuania",
    iso: "LT",
    format: "LT-NNNNN",
    regex: "^[Ll][Tt][- ]{0,1}\\d{5}$"
  },
  {
    note: "References: http://www.upu.int/post_code/en/countries/LUX.pdf",
    country: "Luxembourg",
    iso: "LU",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "[2]",
    country: "Macau",
    iso: "MO",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Macedonia",
    iso: "MK",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Madagascar",
    iso: "MG",
    format: "NNN",
    regex: "^\\d{3}$"
  },
  {
    note: "",
    country: "Malawi",
    iso: "MW",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Maldives",
    iso: "MV",
    format: "NNNN, NNNNN",
    regex: "^\\d{4,5}$"
  },
  {
    note: "",
    country: "Malaysia",
    iso: "MY",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Mali",
    iso: "ML",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Kodiċi Postali",
    country: "Malta",
    iso: "MT",
    format: "AAANNNN (AAA NNNN)",
    regex: "^[A-Za-z]{3}\\s{0,1}\\d{4}$"
  },
  {
    note: "U.S. ZIP codes. Range 96960 - 96970.",
    country: "Marshall Islands",
    iso: "MH",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Mauritania",
    iso: "MR",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Mauritius",
    iso: "MU",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Overseas Department of France. French codes used. Range 97200 - 97290.",
    country: "Martinique",
    iso: "MQ",
    format: "972NN",
    regex: "^972\\d{2}$"
  },
  {
    note: "Overseas Department of France. French codes used. Range 97600 - 97690.",
    country: "Mayotte",
    iso: "YT",
    format: "976NN",
    regex: "^976\\d{2}$"
  },
  {
    note: "US ZIP Code. Range 96941 - 96944.",
    country: "Micronesia",
    iso: "FM",
    format: "NNNNN or NNNNN-NNNN",
    regex: "^\\d{5}(-{1}\\d{4})$"
  },
  {
    note: "The first two digits identify the state (or a part thereof), except for Nos. 00 to 16, which indicate delegaciones (boroughs) of the Federal District (Mexico City).",
    country: "Mexico",
    iso: "MX",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "U.S. ZIP codes. Range 96941 - 96944.",
    country: "Micronesia",
    iso: "FM",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Moldova",
    iso: "MD",
    format: "CCNNNN (CC-NNNN)",
    regex: "^[Mm][Dd][- ]{0,1}\\d{4}$"
  },
  {
    note: "Uses the French Postal System, but with an \"MC\" Prefix for Monaco.",
    country: "Monaco",
    iso: "MC",
    format: "980NN",
    regex: "^980\\d{2}$"
  },
  {
    note: "First digit: region / zone&#10;Second digit: province / district&#10;Last three digits: locality / delivery block[7]",
    country: "Mongolia",
    iso: "MN",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Montenegro",
    iso: "ME",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Montserrat",
    iso: "MS",
    format: "MSR 1110-1350",
    regex: "^[Mm][Ss][Rr]\\s{0,1}\\d{4}$"
  },
  {
    note: "",
    country: "Morocco",
    iso: "MA",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Mozambique",
    iso: "MZ",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Myanmar",
    iso: "MM",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Postal Code ranges from 9000-9299 (note: mainly 9000 is used)",
    country: "Namibia",
    iso: "NA",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Nauru",
    iso: "NR",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Nepal",
    iso: "NP",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "The combination of the postcode and the housenumber gives a unique identifier of the address.",
    country: "Netherlands",
    iso: "NL",
    format: "NNNN AA",
    regex: "^\\d{4}\\s{0,1}[A-Za-z]{2}$"
  },
  {
    note: "Overseas Department of France. French codes used. Range 98800 - 98890.",
    country: "New Caledonia",
    iso: "NC",
    format: "988NN",
    regex: "^988\\d{2}$"
  },
  {
    note: "Postcodes were originally intended for bulk mailing and were not needed for addressing individual items. However, new post codes for general use were phased in from June 2006 and came into force by July 2008.",
    country: "New Zealand",
    iso: "NZ",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Nicaragua",
    iso: "NI",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Niger",
    iso: "NE",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Nigeria",
    iso: "NG",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "",
    country: "Niue",
    iso: "NU",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Part of the Australian postal code system.",
    country: "Norfolk Island",
    iso: "NF",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "U.S. ZIP codes. Range 96950 - 96952.",
    country: "Northern Mariana Islands",
    iso: "MP",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "From south to north",
    country: "Norway",
    iso: "NO",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Deliveries to P.O. Boxes only.",
    country: "Oman",
    iso: "OM",
    format: "NNN",
    regex: "^\\d{3}$"
  },
  {
    note: "Pakistan postal codes list",
    country: "Pakistan",
    iso: "PK",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "U.S. ZIP codes. All locations 96940.",
    country: "Palau",
    iso: "PW",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Panama",
    iso: "PA",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "",
    country: "Papua New Guinea",
    iso: "PG",
    format: "NNN",
    regex: "^\\d{3}$"
  },
  {
    note: "",
    country: "Paraguay",
    iso: "PY",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Peru",
    iso: "PE",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Philippines",
    iso: "PH",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "UK territory, but not UK postcode",
    country: "Pitcairn Islands",
    iso: "PN",
    format: "AAAANAA one code: PCRN 1ZZ",
    regex: "^[Pp][Cc][Rr][Nn]\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "",
    country: "Poland",
    iso: "PL",
    format: "NNNNN (NN-NNN)",
    regex: "^\\d{2}[- ]{0,1}\\d{3}$"
  },
  {
    note: "",
    country: "Portugal",
    iso: "PT",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "",
    country: "Portugal",
    iso: "PT",
    format: "NNNN-NNN (NNNN NNN)",
    regex: "^\\d{4}[- ]{0,1}\\d{3}$"
  },
  {
    note: "U.S. ZIP codes. ZIP codes 006XX for NW PR, 007XX for SE PR, in which XX designates the town or post office and 009XX for the San Juan Metropolitan Area, in which XX designates the area or borough of San Juan. The last four digits identify an area within the post office. For example 00716-2604: 00716-for the east section of the city of Ponce and 2604 for Aceitillo St. in the neighborhood of Los Caobos. US Post office is changing the PR address format to the American one: 1234 No Name Avenue, San Juan, PR 00901.",
    country: "Puerto Rico",
    iso: "PR",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Qatar",
    iso: "QA",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Overseas Department of France. French codes used. Range 97400 - 97490.",
    country: "Réunion",
    iso: "RE",
    format: "974NN",
    regex: "^974\\d{2}$"
  },
  {
    note: "Previously 99999 in Bucharest and 9999 in rest of country.",
    country: "Romania",
    iso: "RO",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Placed on a line of its own.",
    country: "Russia",
    iso: "RU",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Overseas Collectivity of France. French codes used.",
    country: "Saint Barthélemy",
    iso: "BL",
    format: "97133",
    regex: "^97133$"
  },
  {
    note: "Single code used for all addresses.",
    country: "Saint Helena",
    iso: "SH",
    format: "STHL 1ZZ",
    regex: "^[Ss][Tt][Hh][Ll]\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "",
    country: "Saint Kitts and Nevis",
    iso: "KN",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Saint Lucia",
    iso: "LC",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Overseas Collectivity of France. French codes used.",
    country: "Saint Martin",
    iso: "MF",
    format: "97150",
    regex: "^97150$"
  },
  {
    note: "Overseas Collectivity of France. French codes used.",
    country: "Saint Pierre and Miquelon",
    iso: "PM",
    format: "97500",
    regex: "^97500$"
  },
  {
    note: "",
    country: "Saint Vincent and the Grenadines",
    iso: "VC",
    format: "CCNNNN",
    regex: "^[Vv][Cc]\\d{4}$"
  },
  {
    note: "With Italy, uses a five-digit numeric CAP of Emilia Romagna. Range 47890 and 47899",
    country: "San Marino",
    iso: "SM",
    format: "4789N",
    regex: "^4789\\d$"
  },
  {
    note: "",
    country: "Sao Tome and Principe",
    iso: "ST",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "A complete 13-digit code has 5-digit number representing region, sector, city, and zone; 4-digit X between 2000 and 5999; 4-digit Y between 6000 and 9999 [3]. Digits of 5-digit code may represent postal region, sector, branch, section, and block respectively [4].",
    country: "Saudi Arabia",
    iso: "SA",
    format: "NNNNN for PO Boxes. NNNNN-NNNN for home delivery.",
    regex: "^\\d{5}(-{1}\\d{4})?$"
  },
  {
    note: "The letters CP or C.P. are often written in front of the postcode. This is not a country code, but simply an abbreviation for \"code postal\".",
    country: "Senegal",
    iso: "SN",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Poštanski adresni kod (PAK)",
    country: "Serbia",
    iso: "RS",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Serbia",
    iso: "RS",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Seychelles",
    iso: "SC",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Sint Maarten",
    iso: "SX",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Sierra Leone",
    iso: "SL",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Singapore",
    iso: "SG",
    format: "NN",
    regex: "^\\d{2}$"
  },
  {
    note: "",
    country: "Singapore",
    iso: "SG",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Each building has its own unique postcode.",
    country: "Singapore",
    iso: "SG",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "with Czech Republic from west to east, Poštové smerovacie číslo (PSČ) - postal routing number.",
    country: "Slovakia",
    iso: "SK",
    format: "NNNNN (NNN NN)",
    regex: "^\\d{5}\\s\\(\\d{3}\\s\\d{2}\\)$"
  },
  {
    note: "",
    country: "Slovenia",
    iso: "SI",
    format: "NNNN (CC-NNNN)",
    regex: "^([Ss][Ii][- ]{0,1}){0,1}\\d{4}$"
  },
  {
    note: "",
    country: "Solomon Islands",
    iso: "SB",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "A 5 digit code has been publicized, but never taken into use.",
    country: "Somalia",
    iso: "SO",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Postal codes are allocated to individual Post Office branches, some have two codes to differentiate between P.O. Boxes and street delivery addresses. Included Namibia (ranges 9000-9299) until 1992, no longer used.",
    country: "South Africa",
    iso: "ZA",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "One code for all addresses.",
    country: "South Georgia and the South Sandwich Islands",
    iso: "GS",
    format: "SIQQ 1ZZ",
    regex: "^[Ss][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "",
    country: "South Korea",
    iso: "KR",
    format: "NNNNNN (NNN-NNN)",
    regex: "^\\d{6}\\s\\(\\d{3}-\\d{3}\\)$"
  },
  {
    note: "First two indicate the province, range 01-52",
    country: "Spain",
    iso: "ES",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Reference: http://mohanjith.net/ZIPLook/ Incorporates Colombo postal districts, e.g.: Colombo 1 is \"00100\". You can search for specific postal codes here.",
    country: "Sri Lanka",
    iso: "LK",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Sudan",
    iso: "SD",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Suriname",
    iso: "SR",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "The letter identifies one of the country's four districts.",
    country: "Swaziland",
    iso: "SZ",
    format: "ANNN",
    regex: "^[A-Za-z]\\d{3}$"
  },
  {
    note: "",
    country: "Sweden",
    iso: "SE",
    format: "NNNNN (NNN NN)",
    regex: "^\\d{3}\\s*\\d{2}$"
  },
  {
    note: "With Liechtenstein, ordered from west to east. In Geneva and other big cities, like Basel, Bern, Zurich, there may be one or two digits after the name of the city when the generic City code (1211) is used instead of the area-specific code (1201, 1202...), e.g.: 1211 Geneva 13. The digit identifies the post office. This addressing is generally used for P.O. box deliveries.",
    country: "Switzerland",
    iso: "CH",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "Norway postal codes",
    country: "Svalbard and Jan Mayen",
    iso: "SJ",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "A 4-digit system has been announced. Status unknown.",
    country: "Syria",
    iso: "SY",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "The first three digits of the postal code are required; the last two digits are optional. Codes are known as youdi quhao (郵遞區號), and are also assigned to Senkaku Islands (Diaoyutai), though Japanese-administered, the Pratas Islands and the Spratly Islands. See List of postal codes in Taiwan.",
    country: "Taiwan",
    iso: "TW",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Retained system from former Soviet Union.",
    country: "Tajikistan",
    iso: "TJ",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "",
    country: "Tanzania",
    iso: "TZ",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "The first two specify the province, numbers as in ISO 3166-2:TH, the third and fourth digits specify a district (amphoe)",
    country: "Thailand",
    iso: "TH",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "Togo",
    iso: "TG",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Tokelau",
    iso: "TK",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Tonga",
    iso: "TO",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "First two digits specify a postal district (one of 72), next two digits a carrier route, last two digits a building or zone along that route",
    country: "Trinidad and Tobago",
    iso: "TT",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Single code used for all addresses.",
    country: "Tristan da Cunha",
    iso: "SH",
    format: "TDCU 1ZZ",
    regex: "^[Tt][Dd][Cc][Uu]\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "",
    country: "Tunisia",
    iso: "TN",
    format: "NNNN",
    regex: "^\\d{4}$"
  },
  {
    note: "First two digits are the city numbers.[8]",
    country: "Turkey",
    iso: "TR",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Retained system from former Soviet Union.",
    country: "Turkmenistan",
    iso: "TM",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Single code used for all addresses.",
    country: "Turks and Caicos Islands",
    iso: "TC",
    format: "TKCA 1ZZ",
    regex: "^[Tt][Kk][Cc][Aa]\\s{0,1}[1][Zz]{2}$"
  },
  {
    note: "",
    country: "Tuvalu",
    iso: "TV",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Uganda",
    iso: "UG",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Ukraine",
    iso: "UA",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "",
    country: "United Arab Emirates",
    iso: "AE",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Known as the postcode. The first letter(s) indicate the postal area, such as the town or part of London. Placed on a separate line below the city (or county, if used). The UK postcode is made up of two parts separated by a space. These are known as the outward postcode and the inward postcode. The outward postcode is always one of the following formats: AN, ANN, AAN, AANN, ANA, AANA, AAA. The inward postcode is always formatted as NAA. A valid inward postcode never contains the letters: C, I, K, M, O or V. The British Forces Post Office has a different system, but as of 2012 has also adopted UK-style postcodes that begin with \"BF1\" for electronic compatibility.",
    country: "United Kingdom",
    iso: "GB",
    format: "A(A)N(A/N)NAA (A[A]N[A/N] NAA)",
    regex: "^[A-Z]{1,2}[0-9R][0-9A-Z]?\\s*[0-9][A-Z-[CIKMOV]]{2}"
  },
  {
    note: "Known as the ZIP Code with five digits 99999* or the ZIP+4 Code with nine digits 99999-9999* (while the minimum requirement is the first five digits, the U.S. Postal Service encourages everyone to use all nine). Also used by the former US Pacific Territories: Federated States of Micronesia; Palau; and the Marshall Islands, as well as in current US territories American Samoa, Guam, Northern Mariana Islands, Puerto Rico, and the United States Virgin Islands. An individual delivery point may be represented as an 11-digit number, but these are usually represented by Intelligent Mail barcode or formerly POSTNET bar code.",
    country: "United States",
    iso: "US",
    format: "NNNNN (optionally NNNNN-NNNN)",
    regex: "^\\b\\d{5}\\b(?:[- ]{1}\\d{4})?$"
  },
  {
    note: "",
    country: "Uruguay",
    iso: "UY",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "U.S. ZIP codes. Range 00801 - 00851.",
    country: "U.S. Virgin Islands",
    iso: "VI",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "Почтовые индексы",
    country: "Uzbekistan",
    iso: "UZ",
    format: "NNN NNN",
    regex: "^\\d{3} \\d{3}$"
  },
  {
    note: "",
    country: "Vanuatu",
    iso: "VU",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "Single code used for all addresses. Part of the Italian postal code system.",
    country: "Vatican",
    iso: "VA",
    format: "120",
    regex: "^120$"
  },
  {
    note: "",
    country: "Venezuela",
    iso: "VE",
    format: "NNNN or NNNN A",
    regex: "^\\d{4}(\\s[a-zA-Z]{1})?$"
  },
  {
    note: "First two indicate a province.",
    country: "Vietnam",
    iso: "VN",
    format: "NNNNNN",
    regex: "^\\d{6}$"
  },
  {
    note: "Overseas Department of France. French codes used. Range 98600 - 98690.",
    country: "Wallis and Futuna",
    iso: "WF",
    format: "986NN",
    regex: "^986\\d{2}$"
  },
  {
    note: "System for Sana'a Governorate using geocoding \"عنواني\" based on the OpenPostcode algorithm is inaugurated in 2014.[9]",
    country: "Yemen",
    iso: "YE",
    format: "- no codes -",
    regex: ""
  },
  {
    note: "",
    country: "Zambia",
    iso: "ZM",
    format: "NNNNN",
    regex: "^\\d{5}$"
  },
  {
    note: "System is being planned.",
    country: "Zimbabwe",
    iso: "ZW",
    format: "- no codes -",
    regex: ""
  }
];

let defaultPostalCode = {
  note: "",
  country: "",
  iso: "",
  format: "",
  regex: ""
};

export {
  defaultPostalCode,
  postalCode,
}
/* No side effect */
